import { select, Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { TpTemplateModel } from "../_models";
import { TpTemplateState } from "../_reducers";
import { tpTemplateSelectors } from "../_selectors";
import { TemplateTableDataSource } from "./base-template.datasource";

export class TpTemplateDataSource extends TemplateTableDataSource<TpTemplateModel> {
    constructor(private store: Store<TpTemplateState>) {
        super();

        this.isLoading$ = this.store.select(tpTemplateSelectors.selectIsLoading);
        this.total$ = this.store.select(tpTemplateSelectors.selectTotal);

        this.store.pipe(
            takeUntil(this.destroy$),
            select(tpTemplateSelectors.selectTpTemplates)
        ).subscribe(res => {
            this.entitySubject$.next(res);
        })
    }
}